export const createRegion = (regionName, axiosData, selectedFilter, index) => {


    const filteredItems = axiosData?.values.filter(
        (item) =>
            (selectedFilter === "region-all" ||
                item[5].toLowerCase().includes(selectedFilter.slice(7))) &&
            item[4].startsWith(regionName)
    );

    // If there are no filtered items, return null
    if (filteredItems.length === 0) {
        return null;
    }

    return (
        <div className="position-region">
            {regionName.startsWith("SPECIAL") ? (
                <h5 className="region-header-special">
                    {regionName.split("-")[1].toUpperCase()}
                </h5>
            ) : (
                <h5 className="region-header">{regionName.toLowerCase()}</h5>
            )}
            <table>
                <tbody>
                    {axiosData?.values.map((item, index) => {
                        if (item[4].startsWith(regionName)) {
                            return (
                                <tr key={index}>
                                    <td>
                                        <span className="small-text-inner">Vessel</span><br />
                                        <span className="name-of-ship">
                                            {item[0].split("=")[0].toUpperCase()}
                                        </span>
                                        <br />
                                        <span className="specs-of-ship">
                                            {item[0].split("=")[1].split("-")[0]}
                                            {/* {console.log(item[0].split("=")[1].split("-")[0])} */}

                                            {item[0].split("=")[1].split("-")[1] && <br />}
                                            {item[0].split("=")[1].split("-")[1] &&
                                                item[0].split("=")[1].split("-")[1]}

                                            {item[0].split("=")[1].split("-")[2] && <br />}
                                            {item[0].split("=")[1].split("-")[2] &&
                                                item[0].split("=")[1].split("-")[2]}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="small-text-inner">
                                            Current Location
                                        </span>
                                        <br />
                                        {/* {item[1].split("-")[0]} */}
                                        <span className="inner-table-header"> {item[1].split("-")[0].toLowerCase().includes("med")
                                            ? item[1].split("-")[0].replace("Med", "Mediterranean")
                                            : item[1].split("-")[0]}
                                            <br />
                                            {item[1].split("-")[1]}</span>
                                    </td>
                                    <td>
                                        {" "}
                                        <span className="small-text-inner">Direction</span>
                                        <br />
                                        <span className="inner-table-header">{item[2]}</span>
                                    </td>
                                    <td>
                                        <span className="small-text-inner">Looking for</span>
                                        <br />
                                        <span className="inner-table-header">{item[3]}</span>
                                    </td>
                                </tr>
                            );
                        }
                    })}
                </tbody>
            </table>
        </div>
    );
};